import { IActionResult } from '../types/IActionResult';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ISetContentControlledPermissionsParams {
  ids: string[];
  nestedProjectsPermissionsIncluded?: boolean;
}

export class SetContentControlledPermissionsRequest
    extends Request<ISetContentControlledPermissionsParams, IActionResult> {
  constructor(params: ISetContentControlledPermissionsParams) {
    super('setContentControlledPermissions', params);
  }
}
